
import _ from 'lodash'
var _memoryStore = {}

export default class Storage {
	sendRequest () {
		// Use vue-resource or any other http library to send your request
		console.debug('Storage Class in on')
	}
	// Retrieve an item from memory or local storage
	// Allow search by itemKey or { key:subkey }
	findItem (itemKey, storedInLocal) {
		var out = ''
		var iKey = false
		var iField = false

		if (_.isObject(itemKey)) {
			iKey = Object.keys(itemKey)[0]
			iField = itemKey[iKey]
		}

		if (storedInLocal) {
			try {
				if (iKey) {
					out = JSON.parse(localStorage.getItem(iKey))[iField]
				} else {
					out = JSON.parse(localStorage.getItem(itemKey))
				}
			} catch (e) {
				out = localStorage.getItem(itemKey)
			}
		} else {
			if (iKey) {
				out = (_memoryStore[iKey][iField] !== 'undefined') ? _memoryStore[itemKey][iKey] : null
			} else {
				out = (_memoryStore[itemKey] !== 'undefined') ? _memoryStore[itemKey] : null
			}
		}
		return out
	}
	// Store an item from memory or local storage
	setItem (itemKey, item, storeInLocal) {
		if (storeInLocal) {
			// console.debug('Storing item', service._username+'-'+itemKey)
			var itemToStore = (_.isObject(item)) ? JSON.stringify(item) : item
			localStorage.setItem(itemKey, itemToStore)
		} else {
			_memoryStore[itemKey] = item
		}
	}
	// Add content for existing item in memory or local storage
	addItem (itemKey, item, storeInLocal) {
		if (storeInLocal) {
			var storedItem = localStorage.getItem(itemKey)
			var itemToStore = false
			if (storedItem) {
				try {
					itemToStore = JSON.stringify(_.merge(JSON.parse(storedItem), item))
				} catch (e) {
					itemToStore = storedItem + item
				}
			} else {
				itemToStore = (_.isObject(item)) ? JSON.stringify(item) : item
			}
			localStorage.setItem(itemKey, itemToStore)
		} else {
			if (typeof _memoryStore[itemKey] !== 'undefined') {
				if (_.isObject(item)) {
					_memoryStore[itemKey] = _.merge(_memoryStore[itemKey], item)
				} else {
					_memoryStore[itemKey] = _memoryStore[itemKey] + item
				}
			} else {
				_memoryStore[itemKey] = item
			}
		}
	}

	// Remove an item from memory or local storage
	removeItem (itemKey, storedInLocal) {
		var iKey = false
		var iField = false

		if (_.isObject(itemKey)) {
			iKey = Object.keys(itemKey)[0]
			iField = itemKey[iKey]
		}

		if (storedInLocal) {
			if (iKey) {
				var items = JSON.parse(localStorage.getItem(iKey))
				delete items[iField]
				localStorage.setItem(iKey, JSON.stringify(items))
			} else {
				localStorage.removeItem(itemKey)
			}
		} else {
			if (iKey) {
				delete _memoryStore[iKey][iField]
			} else {
				delete _memoryStore[itemKey]
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/commonSite/StorageService.js